export default __webpack_public_path__ + "static/media/wrong_answer.e8da9834.svg";